import { render, staticRenderFns } from "./PlatformSpecification.vue?vue&type=template&id=04d78582&lang=pug"
import script from "./PlatformSpecification.vue?vue&type=script&lang=ts"
export * from "./PlatformSpecification.vue?vue&type=script&lang=ts"
import style0 from "./PlatformSpecification.vue?vue&type=style&index=0&id=04d78582&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports